import {
  CoreType,
  Kpi as KpiT,
  KpiQuery as KpiQueryT,
  KpiResult as KpiResultT,
  KpiResponse as KpiResponseT,
  FilterQueryDefault
} from '../shared/Contracts'

export type InformationResponse = {
  numberOf: Partial<Record<CoreType, number>>
  optionsWithData: {
    complexes: string[]
    constructions: string[]
    levels: string[]
    coClasses: string[]
  }
}

export type KpiType =
  | 'TEMPERATURE_AVERAGE'
  | 'HUMIDITY_AVERAGE'
  | 'CO2_AVERAGE'
  | 'ICI'
  | 'ICI_TEMPERATURE_COMFORT_COOL'
  | 'ICI_TEMPERATURE_COMFORT_WARM'
  | 'ICI_TEMPERATURE_STABILITY'
  | 'ICI_CO2'

export type KpiParameters = object
export type Kpi = KpiT<KpiType, KpiParameters>
export type KpiQuery = KpiQueryT<FilterQueryDefault, KpiType, KpiParameters>
export type KpiResult = KpiResultT<KpiType>
export type KpiResponse = KpiResponseT<FilterQueryDefault, KpiType>
// Test

export type TimeSeriesQuerySplit = {
  aggregations: Aggregation[]
  splitBy?: CoreType
}

export type TimeSeriesQuery = {
  filter: FilterQueryDefault
  splits: TimeSeriesQuerySplit[]
}

export type DataSourceType = 'TEMPERATURE' | 'HUMIDITY' | 'CO2'
export type BucketSize =
  | 'MINUTE_10'
  | 'HOUR'
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR'
  | 'MAX'
export const bucketSizeToInterval: Record<BucketSize, string> = {
  MINUTE_10: '10 minutes',
  HOUR: '1 hour',
  DAY: '1 day',
  WEEK: '1 week',
  MONTH: '1 month',
  QUARTER: '3 months',
  YEAR: '1 year',
  MAX: '1 year'
}
export const intervalToBucketSize: Record<string, BucketSize> = {
  '10 minutes': 'MINUTE_10',
  '1 hour': 'HOUR',
  '1 day': 'DAY',
  '1 week': 'WEEK',
  '1 month': 'MONTH',
  '3 months': 'QUARTER',
  '1 year': 'YEAR'
}
export type AggregationMethod = 'MEAN' | 'MIN' | 'MAX'

export type Aggregation = {
  source: DataSourceType
  bucketSize: BucketSize
  bucketAggregationMethod: AggregationMethod
  spaceAggregationMethod: AggregationMethod
}

export type TimeSeriesValue = {
  timestamp: string
  value: number | null
}

export type TimeSeriesSplit = {
  numberOf: Partial<Record<CoreType, number>>
  splitKey?: string
  values: TimeSeriesValue[]
}

export type TimeSeries = {
  aggregation: Aggregation
  splitBy?: CoreType
  splits: TimeSeriesSplit[]
}

export type TimeSeriesResponse = {
  filter: FilterQueryDefault
  timeSeries: TimeSeries[]
}

export type HistogramConfig = {
  source: DataSourceType
  sourceType: AggregationMethod
  bucketSize: number
  min: number
  max: number
}

export type HistogramQuery = {
  filter: FilterQueryDefault
  histograms: HistogramConfig[]
}

export type Histogram = {
  config: HistogramConfig
  values: HistogramValue[]
}

export type HistogramResponse = {
  histograms: Histogram[]
}

export type HistogramValue = {
  start: number | string
  end: number | string
  value: number
}

export type HistogramValueNew = {
  start: number | null
  end: number | null
  value: number
}

export type HeatmapSplitBy = CoreType | 'SUB_MEASUREMENT'

export type HeatmapQuery = {
  filter: FilterQueryDefault
  splitBy: HeatmapSplitBy
}

export type HeatmapResponse = {
  filter: FilterQueryDefault
  axes: {
    x: (string | null)[]
    y: (string | null)[]
  }
  summary: {
    x: (number | null)[]
    y: (number | null)[]
  }
  matrix: (number | null)[][]
  splitBy: HeatmapSplitBy
}

export type MeasurementType =
  | 'TEMPERATURE_AVERAGE'
  | 'HUMIDITY_AVERAGE'
  | 'CO2_AVERAGE'
  | 'USED_AND_NOT_BOOKED'
  | 'USED_AND_BOOKED'
  | 'BOOKED_AND_NOT_USED'

export type ToplistQuery = {
  filter: FilterQueryDefault
  measurementTypes: MeasurementType[]
  sortBy: MeasurementType
  sortOrder: 'ASCENDING' | 'DESCENDING'
  splitBy: CoreType
  limit: number
}

export type ToplistResponse = {
  filter: FilterQueryDefault
  axis: { x: string[]; y: MeasurementType[] }
  min: number
  max: number
  values: number[][]
}
